import dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';

import { formatDuration } from './formatDuration';

dayjs.extend(duration);

// Helper function that calculates the time remaining from now until a specified end time in Dayjs format
// and returns a human-readable string (with help from formatDuration) indicating time remaining
// e.g. "2 hr 7 min remaining", "13 min remaining", "Less than a minute remaining"
export const getTimeRemaining = (now: Dayjs, endTime: Dayjs) => {
  const timeRemaining = dayjs.duration(endTime.diff(now));
  if (now.isAfter(endTime)) {
    // if we're already past the end time, return null
    return null;
  } else if (timeRemaining.minutes() > 0) {
    const timeRemainingInSeconds = Math.floor(timeRemaining.asSeconds());
    return `${formatDuration(timeRemainingInSeconds)} remaining`;
  } else {
    return 'Less than a minute remaining';
  }
};
